import { BookData } from './types';

export const validateStep1 = (bookData: BookData): boolean => {
  return !!(bookData.language && bookData.title.trim() && bookData.author.trim());
};

export const validateStep2 = (bookData: BookData): boolean => {
  return !!bookData.bookSize;
};

export const validateStep3 = (bookData: BookData): boolean => {
  const hasUploadedFile = !!bookData.uploadedFile;
  const hasContent = !!bookData.content?.html && bookData.content.html.trim().length > 0;
  return hasUploadedFile || hasContent;
};

export const validateStep4 = (bookData: BookData): boolean => {
  const hasCoverImage = !!bookData.coverImage;
  const hasCoverDesignAddon = !!bookData.addons?.coverDesign;
  return hasCoverImage || hasCoverDesignAddon;
};

// Editor-content books created after this feature shipped (requiresPageCountApproval)
// need an explicit, unstale, Puppeteer-verified page-count approval before Cover —
// uploaded-file books and pre-existing books are exempt.
export const validateStepPreview = (bookData: BookData): boolean => {
  const hasContent = !!bookData.content?.html && bookData.content.html.trim().length > 0;
  if (!hasContent || !bookData.requiresPageCountApproval) return true;
  return !!bookData.approvedContentHash && !bookData.pageCountApprovalStale;
};

export const replaceId = (endpoint: string, id: string) => endpoint.replace(':id', id);
